/**
 * iframeInitHelper.js
 *
 * Widget-side utility. Call `initHeightReporter()` once after the app mounts.
 * It reports the app container's height to the parent frame via postMessage
 * whenever the content size changes, using ResizeObserver.
 *
 * Message format: { type: 'bm-widget:height', height: <number> }
 */
import { isEmbeddedInIframe } from '@/util/iframe.js';

let lastHeight = 0;

function sendHeight(container) {
  if (!isEmbeddedInIframe()) return;
  const height = Math.ceil(container.getBoundingClientRect().height);
  if (height === lastHeight) return;
  lastHeight = height;
  window.parent.postMessage({ type: 'bm-widget:height', height: height }, '*');
}

export function initHeightReporter(containerId = 'rtt') {
  if (!isEmbeddedInIframe()) return;

  const container = document.getElementById(containerId);
  if (!container) return;

  // Send immediately
  sendHeight(container);

  const observer = new ResizeObserver(function () {
    sendHeight(container);
  });
  observer.observe(container);
}

export function requestScrollToWidget() {
  if (!isEmbeddedInIframe()) return;
  window.parent.postMessage({ type: 'bm-widget:scroll-into-view' }, '*');
}

export function initRootElementStyles(isAutoHeight = false) {
  if (!isEmbeddedInIframe()) return;

  if (isAutoHeight) {
    // Prevent the iframe document itself from showing scrollbars
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    // this class will be used under components as a conditional selector
    document.documentElement.classList.add('iframe-auto-height');
  } else {
    // If not auto height, make sure the iframe document can scroll if needed
    document.documentElement.style.overflow = 'auto';
    document.body.style.overflow = 'auto';
  }
}
